<template>
  <b-tabs
    ref="tabs"
    pills
    content-class="mt-2 mb-4"
    v-if="value"
    v-model="tabIndex">
    <b-modal
      ref="loadingModal"
      size="lg"
      hide-header
      hide-footer
      content-class="m-0 p-0"
      body-class="m-0 p-0">
      <loader class="m-0"></loader>
    </b-modal>

    <!--
    ============================================================================
    TAB Generale
    ============================================================================
    -->
    <b-tab>
      <template slot="title">
        Generale
        <b-badge variant="danger"
          v-if="countErrors(['title', 'description'])">
          {{ countErrors(['title', 'description']) }}
        </b-badge>
      </template>
      <general
        :disabled="disabled"
        :errors="errors"
        :value="value"
        @input="$emit('input', $event)" />
    </b-tab>
    <!--
    ============================================================================
    TAB Condivisione
    ============================================================================
    -->
    <b-tab v-if="value.shares" class="pt-0">
      <template slot="title">
        Condivisione
        <b-badge variant="danger"
          v-if="countErrors('shares')">
          {{ countErrors('shares') }}
        </b-badge>
      </template>
      <shares
        :disabled="disabled"
        :errors="errors"
        :value="value"
        @input="$emit('input', $event)" />
    </b-tab>
    <!--
    ============================================================================
    TAB Inviti
    ============================================================================
    -->
    <b-tab v-if="value.invitations" class="pt-0">
      <template slot="title">
        Inviti
        <b-badge variant="danger"
          v-if="countErrors('invitations')">
          {{ countErrors('invitations') }}
        </b-badge>
      </template>
      <invitations
        :disabled="disabled"
        :errors="errors"
        :value="value"
        @input="$emit('input', $event)" />
    </b-tab>
    <!--
    ============================================================================
    TAB Messaggi
    ============================================================================
    -->
    <!--
    <b-tab v-if="value.id" title="Messaggi" id="messages">
      <template slot="title">
        Messaggi
        <b-badge variant="danger" v-if="newMessages">
          {{ newMessages }}
        </b-badge>
      </template>
      <messages
        context="analyses"
        :context-id="value.id"
        @message="onMessage"
      ></messages>
    </b-tab>
    -->
  </b-tabs>
</template>
<script>
import EntityEditorMixin from 'vue-core/mixins/EntityEditorMixin';
import NumberUtilsMixin from 'vue-core/mixins/NumberUtilsMixin';
import FileUtilsMixin from 'vue-core/mixins/FileUtilsMixin';
import CrAnalysisService from 'app/services/CrAnalysisService';
import { downloadBlob } from 'vue-core/utils';
import * as moment from 'moment';
import General from './Analysis/General';
import Shares from './Analysis/Shares';
import Invitations from './Analysis/Invitations';

export default {
  mixins: [ EntityEditorMixin, NumberUtilsMixin, FileUtilsMixin ],

  components: {
    General,
    Shares,
    Invitations
  },

  data() {
    return {
      loading: false,
      tabIndex: 0,
      //newMessages: 0
    };
  },

  watch: {
    loading(newValue) {
      if (newValue) {
        this.$refs.loadingModal.show();
      } else {
        this.$refs.loadingModal.hide();
      }
    },

    tabIndex(newValue) {
      const tab = this.$refs.tabs.tabs[newValue];
      if (tab.id === 'messages') {
        this.newMessages = 0;
      }
    }
  },

  methods: {
    /*
    onMessage(message) {
      const tab = this.$refs.tabs.tabs[this.$refs.tabs.value];
      if (tab.id !== 'messages') {
        this.newMessages++;
      }
    },
    */
  }
}
</script>
